/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable max-lines */
import { useContext } from 'react';
import { InputLabel, MenuItem, Select, Box, Typography, Grid, FormControl } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomSelectStyles as classes } from './CustomSelectStyles';
import { CommonStyles } from '../CommonStyles';

import { SELECT_UTILITY_BILL_TYPE } from '../../../constants';
import { commonTernary } from '../../commonCode';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { DownArrowIcon } from '../../../images/svg/CustomizedSVG';
import alertIcon from '../../../images/alert-triangle.svg';

export const CustomSelect = ({
  id,
  dataTestId,
  required,
  inputLabelAriaLabel,
  inputLabelClassName,
  label,
  autoFocus,
  options,
  InputClassName,
  handleChange,
  fullWidth,
  value,
  selectAriaLabel,
  disabled,
  nsSeparator,
  isState,
  dataTestIdForLabel,
  isUtilityBill,
  error,
  showLabel,
  textLabel,
  isBundle,
  isInputEmpty,
  // noPlaceHolderLabel,
  // corporateTitlePlaceholder,
  isOtherRelation = false,
  isBeneficiaryList = false,
  placeholder,
}) => {
  const { t } = useTranslation();

  const leadGenerationContext = useContext(LeadGenerationContext);
  const { theme } = leadGenerationContext;
  const showError = Boolean(error);

  const commonClasses = CommonStyles(theme);

  const commonSelectFunction = (data1, data2) => {
    let data;
    if (data1) {
      data = data1;
    } else {
      data = data2;
    }
    return data;
  };
  const beneficiaryRenderValue = (selected) => {
    if (!selected)
      return (
        <Typography sx={classes.beneficiarySelectPlaceholder}>
          {t('Select your beneficiary', { defaultValue: 'Select your beneficiary' })}
        </Typography>
      );
    const selectedOption = options.find((item) => item.beneficiaryCustId === selected);
    return selectedOption?.beneficiaryName;
  };

  if (isState) {
    return (
      <>
        <InputLabel
          htmlFor={commonSelectFunction(id, null)}
          data-testid={commonSelectFunction(dataTestIdForLabel, null)}
          required={commonSelectFunction(required, false)}
          aria-label={commonSelectFunction(inputLabelAriaLabel, null)}
          sx={[classes.label_title, commonSelectFunction(inputLabelClassName, '')]}
        >
          {commonSelectFunction(label, '')}
        </InputLabel>
        <Select
          aria-label={commonSelectFunction(selectAriaLabel, null)}
          id={commonSelectFunction(id, null)}
          name={commonSelectFunction(id, null)}
          role="listbox"
          autoFocus={commonSelectFunction(autoFocus, false)}
          inputProps={{ 'data-testid': commonSelectFunction(id, null) }}
          fullWidth={commonSelectFunction(fullWidth, false)}
          value={commonSelectFunction(value, '')}
          onChange={handleChange}
          displayEmpty
          IconComponent={() => (
            <Box padding="0 10px 0 0">
              <DownArrowIcon
                style={{ width: 24, height: 24 }}
                color={theme?.palette?.orientalPrimary?.main}
              />
            </Box>
          )}
          sx={[
            commonSelectFunction(InputClassName, ''),
            classes.select_inputs,
            error && classes.select_inputs_err,
            ...(isBundle
              ? [
                  commonClasses.customBorderRadius,
                  commonClasses.outlined_input_bundle,
                  {
                    borderRadius: '50px !important',
                    color: isInputEmpty
                      ? theme?.palette?.disabled?.main
                      : theme?.palette?.primary?.main,
                    backgroundColor: error ? '#D5151F1A' : theme?.palette?.fieldsBackground?.main,
                    border: error
                      ? `1px solid ${theme?.palette?.danger?.main}`
                      : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                    '&.MuiOutlinedInput-root': {
                      borderRadius: '50px !important',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderRadius: '50px !important',
                      border: 'none !important',
                    },

                    '&.Mui-focused': {
                      border: `1px solid ${theme?.palette?.primary?.main}`,
                    },
                  },
                ]
              : [
                  {
                    '&.Mui-focused': {
                      border: `1px solid ${theme?.palette?.primary?.main}`,
                    },
                  },
                ]),
          ]}
          MenuProps={{
            disableScrollLock: true,
            PaperProps: {
              sx: {
                ...theme?.menuBackground,
                border: `1px solid ${theme?.menuBackground?.borderColor} !important`,
                color: theme?.palette?.primary?.main,
              },
              className: isBundle ? 'bundle-menu-paper' : '',
            },
          }}
          slotProps={{
            icon: {
              sx: classes.select_icon,
            },
            select: {
              sx: [
                commonTernary(
                  value === null || value === '' || value === 'Select',
                  classes.select_style
                ),
                ...(isBundle
                  ? [
                      commonClasses.customBorderRadius,
                      commonClasses.outlined_input_bundle,
                      {
                        borderRadius: '50px !important',
                      },
                    ]
                  : []),
              ],
            },
            notchedOutline: {
              sx: isBundle && {
                borderRadius: '50px !important',
                border: 'none !important',
              },
            },
          }}
        >
          <MenuItem role="option" value="">
            {t('Select', { defaultValue: 'Select' })}
          </MenuItem>
          {nsSeparator
            ? options &&
              Object.keys(options).length > 0 &&
              options.map((option) => (
                <MenuItem key={option.stateInitial} role="option" value={option.stateInitial}>
                  {t(option.stateFullName, {
                    defaultValue: option.stateFullName,
                    nsSeparator,
                  })}
                </MenuItem>
              ))
            : options &&
              Object.keys(options).length > 0 &&
              options.map((option) => (
                <MenuItem key={option.stateInitial} role="option" value={option.stateInitial}>
                  {t(option.stateFullName, { defaultValue: option.stateFullName })}
                </MenuItem>
              ))}
        </Select>
      </>
    );
  }
  if (isUtilityBill) {
    return (
      <>
        <InputLabel
          required={commonSelectFunction(required, false)}
          htmlFor={commonSelectFunction(id, null)}
          aria-label={commonSelectFunction(inputLabelAriaLabel, null)}
          sx={[classes.label_title, commonSelectFunction(inputLabelClassName, '')]}
          data-testid={commonSelectFunction(dataTestIdForLabel, null)}
        >
          {commonSelectFunction(label, '')}
        </InputLabel>
        <Select
          id={commonSelectFunction(id, null)}
          onChange={handleChange}
          sx={commonTernary(
            error,
            [
              commonSelectFunction(InputClassName, ''),
              classes.select_inputs,
              classes.select_inputs_err,
              ...(isBundle
                ? [commonClasses.customBorderRadius, commonClasses.outlined_input_bundle]
                : []),
            ],
            [
              commonSelectFunction(InputClassName, ''),
              classes.select_inputs,
              ...(isBundle
                ? [
                    commonClasses.customBorderRadius,
                    commonClasses.outlined_input_bundle,
                    {
                      '&.Mui-focused': {
                        border: `1px solid ${theme?.palette?.primary?.main}`,
                      },
                    },
                  ]
                : [
                    {
                      '&.Mui-focused': {
                        border: `1px solid ${theme?.palette?.primary?.main}`,
                      },
                    },
                  ]),
            ]
          )}
          role="listbox"
          autoFocus={commonSelectFunction(autoFocus, false)}
          fullWidth={commonSelectFunction(fullWidth, false)}
          inputProps={{ 'data-testid': commonSelectFunction(id, null) }}
          aria-label={commonSelectFunction(selectAriaLabel, null)}
          name={commonSelectFunction(id, null)}
          data-testid={commonSelectFunction(dataTestId, '')}
          value={commonSelectFunction(value, '')}
          IconComponent={() => (
            <Box padding="0 10px 0 0">
              <DownArrowIcon
                style={{ width: 24, height: 24 }}
                color={theme?.palette?.orientalPrimary?.main}
              />
            </Box>
          )}
          displayEmpty
          // disabled={!!disabled}
          MenuProps={{
            disableScrollLock: true,
            PaperProps: {
              sx: {
                ...theme?.menuBackground,
                border: `1px solid ${theme?.menuBackground?.borderColor} !important`,
                color: theme?.palette?.primary?.main,
              },
              className: isBundle ? 'bundle-menu-paper' : '',
            },
          }}
          slotProps={{
            icon: {
              sx: classes.select_icon,
            },
            select: {
              sx: commonTernary(
                value === null || value === '' || value === 'Select',
                classes.select_style,
                ...(isBundle
                  ? [commonClasses.customBorderRadius, commonClasses.outlined_input_bundle]
                  : [])
              ),
            },
            notchedOutline: {
              sx: isBundle && { border: 'none' },
            },
          }}
        >
          <MenuItem role="option" value="">
            -- {t(SELECT_UTILITY_BILL_TYPE, { defaultValue: SELECT_UTILITY_BILL_TYPE })} --
          </MenuItem>
          {commonTernary(
            nsSeparator,
            options &&
              Object.keys(options).length > 0 &&
              options.map((option) => (
                <MenuItem key={option} role="option" value={option}>
                  {t(option, { defaultValue: option, nsSeparator })}
                </MenuItem>
              )),
            options &&
              Object.keys(options).length > 0 &&
              options.map((option) => (
                <MenuItem key={option} role="option" value={option}>
                  {t(option, { defaultValue: option })}
                </MenuItem>
              ))
          )}
        </Select>
      </>
    );
  }

  return (
    <>
      <InputLabel
        data-testid={commonSelectFunction(dataTestIdForLabel, null)}
        htmlFor={commonSelectFunction(id, null)}
        aria-label={commonSelectFunction(inputLabelAriaLabel, null)}
        sx={[classes.label_title, commonSelectFunction(inputLabelClassName, '')]}
        required={commonSelectFunction(required, false)}
      >
        {commonSelectFunction(label, '')}
      </InputLabel>
      <Grid
        size={(isOtherRelation || isBeneficiaryList) && { xs: 12, md: 6 }}
        sx={{ position: 'relative' }}
      >
        <FormControl fullWidth>
          <Select
            role="listbox"
            id={commonSelectFunction(id, null)}
            sx={[
              commonSelectFunction(InputClassName, ''),
              classes.select_inputs,
              error && classes.select_inputs_err,
              disabled && classes.select_inputs_disabled,
              isBundle && commonClasses.customBorderRadius,
              isBundle && commonClasses.outlined_input_bundle,
              {
                ...(isBundle && {
                  borderRadius: '50px',
                  '&.MuiOutlinedInput-root': {
                    borderRadius: '50px',
                  },
                  '&.Mui-focused': {
                    border: `1px solid ${theme?.palette?.primary?.main}`,
                  },
                  backgroundColor: error ? '#D5151F1A' : theme?.palette?.fieldsBackground?.main,
                }),
                border: error
                  ? `1px solid ${theme?.palette?.danger?.main}`
                  : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                color:
                  isBundle && isInputEmpty
                    ? theme?.palette?.disabled?.main
                    : theme?.palette?.primary?.main,
                transition: 'all 0.3s ease',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none !important',
                },
                '& .MuiSelect-icon': {
                  color: theme?.palette?.orientalPrimary?.main,
                },
                '&.Mui-focused': {
                  border: `1px solid ${theme?.palette?.primary?.main}`,
                },
              },
            ]}
            onChange={handleChange}
            disabled={!!disabled}
            name={commonSelectFunction(id, null)}
            inputProps={{ 'data-testid': commonSelectFunction(id, null) }}
            autoFocus={commonSelectFunction(autoFocus, false)}
            aria-label={commonSelectFunction(selectAriaLabel, null)}
            data-testid={commonSelectFunction(dataTestId, '')}
            fullWidth={commonSelectFunction(fullWidth, false)}
            IconComponent={() => (
              <Box padding="0 10px 0 0">
                <DownArrowIcon
                  style={{ width: 24, height: 24 }}
                  color={theme?.palette?.orientalPrimary?.main}
                />
              </Box>
            )}
            value={commonSelectFunction(value, '')}
            renderValue={isBeneficiaryList ? beneficiaryRenderValue : undefined}
            MenuProps={{
              disablePortal: true,
              PaperProps: {
                sx: {
                  position: 'absolute',
                  mt: 1,
                  zIndex: 1300,
                  ...theme?.menuBackground,
                  border: `1px solid ${theme?.menuBackground?.borderColor} !important`,
                  color: theme?.palette?.primary?.main,
                },
                className: isBundle ? 'bundle-menu-paper' : '',
              },
            }}
            slotProps={{
              icon: {
                sx: classes.select_icon,
              },
              select: {
                sx: commonTernary(value === null || value === '' || value === 'Select', [
                  commonTernary(disabled, classes.disable_select_style, classes.select_style),
                  isBundle && commonClasses.customBorderRadius,
                ]),
              },
              notchedOutline: {
                sx: isBundle && { border: 'none !important' },
              },
            }}
            displayEmpty
          >
            {placeholder ? (
              <MenuItem value="" disabled sx={{ display: 'none' }}>
                <Typography sx={classes.beneficiarySelectPlaceholder}>
                  {t(placeholder, { defaultValue: placeholder })}
                </Typography>
              </MenuItem>
            ) : (
              <MenuItem role="option" value="">
                {showLabel
                  ? t(textLabel, { defaultValue: textLabel })
                  : t('Select', { defaultValue: 'Select' })}
              </MenuItem>
            )}
            {isBeneficiaryList
              ? options &&
                options.length > 0 &&
                options.map((option) => (
                  <MenuItem
                    key={option.beneficiaryCustId}
                    role="option"
                    value={option.beneficiaryCustId}
                    sx={{
                      ...classes.beneficiarySelectContainer,
                      padding: '12px 16px',
                      ...(option.beneficiaryAmount < 100 && { pointerEvents: 'none' }),
                    }}
                  >
                    <Box
                      sx={{
                        ...classes.beneficiarySelectContainer,
                        ...(option.beneficiaryAmount < 100 && { opacity: 0.5 }),
                      }}
                    >
                      <Typography sx={classes.beneficiarySelectHeading}>
                        {option.beneficiaryName}
                      </Typography>
                      <Typography sx={classes.beneficiarySelectSubHeading}>
                        {t('contributionBalance', {
                          defaultValue: 'Yearly contribution balance: $',
                        })}
                        {option.beneficiaryAmount}
                      </Typography>
                    </Box>
                    {option.beneficiaryAmount < 100 && (
                      <Grid sx={classes.beneficiaryAlert}>
                        <Box
                          component="img"
                          src={alertIcon}
                          alt="Alert"
                          height="24px"
                          width="24px"
                        />
                        <Typography sx={classes.beneficiaryAlertText}>
                          {t('This beneficiary is ineligible', {
                            defaultValue: 'This beneficiary is ineligible',
                          })}
                        </Typography>
                      </Grid>
                    )}
                  </MenuItem>
                ))
              : commonTernary(
                  nsSeparator,
                  options &&
                    Object.keys(options).length > 0 &&
                    options.map((option) => (
                      <MenuItem key={option} role="option" value={option}>
                        {t(option, { defaultValue: option, nsSeparator })}
                      </MenuItem>
                    )),
                  options &&
                    Object.keys(options).length > 0 &&
                    options.map((option) => (
                      <MenuItem key={option} role="option" value={option}>
                        {t(option, { defaultValue: option })}
                      </MenuItem>
                    ))
                )}
          </Select>
        </FormControl>
      </Grid>
    </>
  );
};

CustomSelect.propTypes = {
  id: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  isBundle: PropTypes.bool,
  inputLabelAriaLabel: PropTypes.string,
  inputLabelClassName: PropTypes.string,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  showLabel: PropTypes.bool,
  textLabel: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  InputClassName: PropTypes.string,
  handleChange: PropTypes.func,
  fullWidth: PropTypes.bool,
  isState: PropTypes.bool,
  isUtilityBill: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectAriaLabel: PropTypes.string,
  dataTestId: PropTypes.string,
  nsSeparator: PropTypes.string,
  dataTestIdForLabel: PropTypes.string,
  isInputEmpty: PropTypes.bool,
  // noPlaceHolderLabel: PropTypes.bool,
  // corporateTitlePlaceholder: PropTypes.bool,
  isOtherRelation: PropTypes.bool,
  isBeneficiaryList: PropTypes.bool,
  placeholder: PropTypes.string,
};
